import { render, staticRenderFns } from "./stdBalanceReport.vue?vue&type=template&id=2b79b770&scoped=true&"
import script from "./stdBalanceReport.vue?vue&type=script&lang=js&"
export * from "./stdBalanceReport.vue?vue&type=script&lang=js&"
import style0 from "./stdBalanceReport.vue?vue&type=style&index=0&id=2b79b770&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b79b770",
  null
  
)

export default component.exports